import { render, staticRenderFns } from "./reportPrePaymentFee.vue?vue&type=template&id=12666eb0&scoped=true"
import script from "./reportPrePaymentFee.vue?vue&type=script&lang=js"
export * from "./reportPrePaymentFee.vue?vue&type=script&lang=js"
import style0 from "./reportPrePaymentFee.vue?vue&type=style&index=0&id=12666eb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12666eb0",
  null
  
)

export default component.exports